import { InstantReactAbstractDatabase } from '@instantdb/react-common';
import { EventSource } from 'eventsource';
class InstantReactWebDatabase extends InstantReactAbstractDatabase {
}
InstantReactWebDatabase.EventSourceImpl = EventSource;
export default InstantReactWebDatabase;
//# sourceMappingURL=InstantReactWebDatabase.js.map